//export const SERVER_URL = "https://dev.opticasweb.com/rest/";
//export const SERVER_URL = "https://dev.opticasweb.com/rest2/";

//export const SERVER_URL = "https://optiwin.es/rest/dev/";
export const SERVER_URL = "https://optiwin.es/rest/prod/";
